import { callTimelineFiltersActionType } from '../../actions/conferenceCall'

const initialState = {
  category: {},
  detail: {
    includeVideoCall: true,
    includeGroupCall: false,
    similarAge: true,
    excludeGomimushi: true,
  },
}

export default function callTimelineFilters(state = initialState, action) {
  switch (action.type) {
    case callTimelineFiltersActionType.set:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      }
    case callTimelineFiltersActionType.setDetail:
      return {
        ...state,
        detail: {
          ...state.detail,
          [action.payload.key]: action.payload.value,
        },
      }

    case callTimelineFiltersActionType.clear:
      return initialState

    case callTimelineFiltersActionType.clearDetail:
      return {
        ...state,
        detail: initialState.detail,
      }

    default:
      return state
  }
}
